export default __webpack_public_path__ + "static/media/DB_logo_red_rgb_100px.7905748b.svg";